export default {
  small: 576,
  medium: 768,
  mediumLarge: 930,
  large: 1024,
  xLarge: 1200,
};
